module.exports = __webpack_public_path__ + "static/media/goblin_shaman_head.11f85da0.svg";